export class PaymentArrangement {
    constructor() {
        this.regularPaymentAmount = 0;
        this.regularPaymentStartDate = new Date();
        this.regularPaymentFrequencyPeriod = 'Weekly';
    }

    regularPaymentAmount: number;
    regularPaymentStartDate: Date;
    regularPaymentFrequencyPeriod: string;
}
